export type CategoryItem = {
  id: string;
  name: string;
  icon: string;
  count: string;
  desc: string;
  examples: string;
};

export const categories: CategoryItem[] = [
  {
    id: "c1",
    name: "电影",
    icon: "ri-movie-2-line",
    count: "长片",
    desc: "以单部作品为单位的剧情长片，涵盖剧情、犯罪、科幻、动画等主流类型，适合一次看完一个完整故事。",
    examples: "剧情长片 · 类型片 · 犯罪片",
  },
  {
    id: "c2",
    name: "电视剧",
    icon: "ri-tv-2-line",
    count: "剧集",
    desc: "以多集连载形式推进的作品，人物线与世界观更完整，适合按周或一次性追完的观看习惯。",
    examples: "连续剧 · 单元剧 · 迷你剧",
  },
  {
    id: "c3",
    name: "最新电影",
    icon: "ri-calendar-line",
    count: "更新中",
    desc: "按上映时间整理的新片入口，适合想优先了解近期关注度较高的影片与题材趋势的用户。",
    examples: "近期上映 · 新片观察 · 题材趋势",
  },
  {
    id: "c4",
    name: "热播剧",
    icon: "ri-fire-line",
    count: "热度",
    desc: "话题度与讨论度较高的剧集集合，适合想跟着热点追剧、避免从零开始挑片的用户。",
    examples: "话题剧 · 口碑剧 · 讨论度高",
  },
  {
    id: "c5",
    name: "欧美大片",
    icon: "ri-earth-line",
    count: "海外",
    desc: "欧美地区的商业大片与高投资制作，视听规格较高，适合重视画面、动作与特效体验的观众。",
    examples: "科幻巨制 · 系列大片 · 动作冒险",
  },
  {
    id: "c6",
    name: "国产剧",
    icon: "ri-building-2-line",
    count: "华语",
    desc: "华语地区的剧集与年代作品，题材贴近本土语境，适合关注现实题材、古装与年代叙事的观众。",
    examples: "古装 · 现实题材 · 年代剧",
  },
];

export type SeriesItem = {
  id: string;
  title: string;
  year: string;
  region: string;
  episodes: string;
  tag: string;
  desc: string;
};

export const hotSeries: SeriesItem[] = [
  {
    id: "s1",
    title: "漫长的季节",
    year: "2023",
    region: "华语",
    episodes: "12 集",
    tag: "悬疑 · 年代",
    desc: "以东北老工业城市为背景的悬疑剧，叙事在时间线之间来回切换，适合喜欢慢节奏与人物群像的观众。",
  },
  {
    id: "s2",
    title: "狂飙",
    year: "2023",
    region: "华语",
    episodes: "39 集",
    tag: "犯罪 · 剧情",
    desc: "围绕正邪对峙展开的犯罪题材剧集，时间跨度较长，适合偏好强情节与角色成长线的观众。",
  },
  {
    id: "s3",
    title: "权力的游戏",
    year: "2011",
    region: "欧美",
    episodes: "多季",
    tag: "奇幻 · 史诗",
    desc: "多家族争夺权力的史诗奇幻剧集，世界观庞大、支线众多，适合能投入长时间连续追剧的观众。",
  },
  {
    id: "s4",
    title: "绝命毒师",
    year: "2008",
    region: "欧美",
    episodes: "5 季",
    tag: "犯罪 · 剧情",
    desc: "以人物转变为线索的犯罪剧，节奏克制、压力感强，适合喜欢角色弧光与道德困境题材的观众。",
  },
  {
    id: "s5",
    title: "琅琊榜",
    year: "2015",
    region: "华语",
    episodes: "54 集",
    tag: "古装 · 权谋",
    desc: "古装权谋题材的华语代表作之一，人物关系复杂、台词讲究，适合喜欢谋略与群像戏的观众。",
  },
  {
    id: "s6",
    title: "老友记",
    year: "1994",
    region: "欧美",
    episodes: "10 季",
    tag: "喜剧 · 生活",
    desc: "经典情景喜剧，单集时长轻松、适合碎片时间观看，也常被当作入门欧美剧集的轻松选择。",
  },
];

export type FeatureItem = {
  id: string;
  title: string;
  original: string;
  year: string;
  meta: string;
  desc: string;
  image: string;
};

export const westernPicks: FeatureItem[] = [
  {
    id: "w1",
    title: "阿凡达",
    original: "Avatar",
    year: "2009",
    meta: "科幻 · 冒险",
    desc: "以异星世界构建为核心的科幻大片，视觉设计是主要看点，适合重视沉浸式画面体验的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20lush%20bioluminescent%20alien%20jungle%20at%20dusk%20with%20warm%20glowing%20plants%2C%20muted%20amber%20emerald%20and%20charcoal%20palette%2C%20soft%20atmospheric%20lighting%2C%20subtle%20film%20grain%2C%20premium%20composition&width=800&height=600&seq=sm-west-01&orientation=landscape",
  },
  {
    id: "w2",
    title: "沙丘",
    original: "Dune",
    year: "2021",
    meta: "科幻 · 史诗",
    desc: "以沙漠星球为舞台的科幻史诗，画面与音效风格统一，适合喜欢宏大世界观与慢燃叙事的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20vast%20rolling%20sand%20dunes%20under%20a%20warm%20hazy%20sun%20with%20tiny%20distant%20figures%2C%20muted%20amber%20ochre%20and%20charcoal%20palette%2C%20minimal%20epic%20lighting%2C%20subtle%20film%20grain%2C%20premium%20composition&width=800&height=600&seq=sm-west-02&orientation=landscape",
  },
  {
    id: "w3",
    title: "007 系列",
    original: "James Bond",
    year: "1962 起",
    meta: "动作 · 谍战",
    desc: "历史悠久的谍战动作系列，单部相对独立、门槛低，适合想看节奏明快的商业动作片的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20sleek%20silhouette%20against%20a%20warm%20city%20skyline%20and%20rain%20streaked%20glass%2C%20muted%20amber%20gold%20and%20charcoal%20palette%2C%20moody%20dramatic%20lighting%2C%20subtle%20film%20grain%2C%20stylish%20composition&width=800&height=600&seq=sm-west-03&orientation=landscape",
  },
  {
    id: "w4",
    title: "复仇者联盟系列",
    original: "The Avengers",
    year: "2012 起",
    meta: "超级英雄 · 动作",
    desc: "多位超级英雄联动的商业系列，前后作品关联较强，适合喜欢群像战斗与连续世界观的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20city%20skyscrapers%20with%20dramatic%20warm%20light%20rays%20breaking%20through%20smoke%2C%20muted%20amber%20red%20and%20charcoal%20palette%2C%20heroic%20dramatic%20lighting%2C%20subtle%20film%20grain%2C%20bold%20composition&width=800&height=600&seq=sm-west-04&orientation=landscape",
  },
];

export const domesticPicks: FeatureItem[] = [
  {
    id: "d1",
    title: "甄嬛传",
    original: "Empresses in the Palace",
    year: "2011",
    meta: "古装 · 宫廷",
    desc: "华语古装宫廷剧的代表作之一，人物关系细腻、台词信息量大，适合喜欢长线权谋与人物的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20an%20ornate%20traditional%20palace%20corridor%20with%20warm%20lantern%20light%20and%20silk%20drapery%2C%20muted%20amber%20crimson%20and%20charcoal%20palette%2C%20elegant%20soft%20lighting%2C%20subtle%20film%20grain%2C%20refined%20composition&width=800&height=600&seq=sm-dom-01&orientation=landscape",
  },
  {
    id: "d2",
    title: "庆余年",
    original: "Joy of Life",
    year: "2019",
    meta: "古装 · 权谋",
    desc: "融合轻喜与权谋元素的古装剧，节奏相对轻快，适合想兼顾爽感与剧情的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20traditional%20courtyard%20with%20stone%20paving%20and%20warm%20bamboo%20shadow%20light%2C%20muted%20amber%20jade%20and%20charcoal%20palette%2C%20soft%20daylight%20lighting%2C%20subtle%20film%20grain%2C%20graceful%20composition&width=800&height=600&seq=sm-dom-02&orientation=landscape",
  },
  {
    id: "d3",
    title: "隐秘的角落",
    original: "The Bad Kids",
    year: "2020",
    meta: "悬疑 · 现实",
    desc: "短集数悬疑剧，以现实题材切入、氛围压抑克制，适合喜欢紧凑节奏与细节伏笔的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20quiet%20coastal%20town%20alley%20at%20warm%20fading%20dusk%20with%20long%20shadows%2C%20muted%20amber%20and%20cool%20charcoal%20palette%2C%20tense%20soft%20lighting%2C%20subtle%20film%20grain%2C%20restrained%20composition&width=800&height=600&seq=sm-dom-03&orientation=landscape",
  },
  {
    id: "d4",
    title: "长安十二时辰",
    original: "The Longest Day in Chang'an",
    year: "2019",
    meta: "古装 · 悬疑",
    desc: "以一天时间线推进的古装悬疑剧，服化道与节奏讲究，适合喜欢强设定与时间压迫感的观众。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20still%20of%20a%20lively%20ancient%20city%20street%20at%20warm%20night%20with%20glowing%20lanterns%20and%20crowds%2C%20muted%20amber%20gold%20and%20charcoal%20palette%2C%20rich%20warm%20lighting%2C%20subtle%20film%20grain%2C%20layered%20composition&width=800&height=600&seq=sm-dom-04&orientation=landscape",
  },
];

export type GuideItem = {
  id: string;
  title: string;
  icon: string;
  summary: string;
  detail: string;
};

export const guideItems: GuideItem[] = [
  {
    id: "g1",
    title: "先定类型，再看片长",
    icon: "ri-compass-3-line",
    summary: "用「类型 + 时长」作为第一层筛选条件，能快速排除大部分不合适的内容。",
    detail: "如果你只有零散时间，优先看单部电影或短集数剧集；如果想长期投入，选择多季或多集的长线剧集。先锁定类型（剧情、科幻、犯罪、动画、喜剧等），再按可支配时间决定是看电影还是追剧，选片效率会明显提升。",
  },
  {
    id: "g2",
    title: "地区风格与叙事差异",
    icon: "ri-global-line",
    summary: "不同地区的作品在叙事节奏、题材侧重与制作风格上通常有较明显的差别。",
    detail: "华语作品在现实题材、年代与古装叙事上积累较多，情感与人物关系往往是重点；欧美作品在科幻、动作与系列化制作上投入更大，视听体验突出。了解这些大致的题材偏好，能帮助你在「欧美大片」与「国产剧」之间更快做出选择。",
  },
  {
    id: "g3",
    title: "系列作品的观看顺序",
    icon: "ri-list-ordered",
    summary: "遇到系列或联动作品时，按上映顺序或时间线顺序观看体验更连贯。",
    detail: "系列大片与多季剧集通常存在前后关联。建议先确认清楚「上映顺序」与「剧情时间线顺序」是否一致，再决定从哪一部开始；如果只想体验单部，也可以先看相对独立、口碑稳定的那一部作为入门。",
  },
  {
    id: "g4",
    title: "用热度与口碑交叉判断",
    icon: "ri-bar-chart-2-line",
    summary: "热度代表讨论度，口碑代表长期评价，两者结合比单看其中一个更可靠。",
    detail: "新片往往热度高但口碑尚未沉淀，经典作品则口碑稳定但话题度较低。把「热播/最新」与「经典/高评价」两类放在一起对照，根据自己的偏好取舍，会比只跟着热度榜单更不容易踩雷。",
  },
];

export type FaqItem = {
  id: string;
  q: string;
  a: string;
};

export const faqs: FaqItem[] = [
  {
    id: "f1",
    q: "神马电影网主要包含哪些内容？",
    a: "页面围绕电影与电视剧两类内容展开，并进一步分为电影、电视剧、最新电影、热播剧、欧美大片、国产剧等方向。你可以先按大类浏览，再通过本页的筛选与搜索缩小范围。",
  },
  {
    id: "f2",
    q: "怎样快速找到最新电影和热播剧？",
    a: "使用导航中的「最新电影」与「热播剧集」入口即可跳转到对应分区。最新电影按新片整理，热播剧集按讨论度整理，两者都提供了简要说明，方便你先了解再决定是否深入。",
  },
  {
    id: "f3",
    q: "欧美大片和国产剧有什么区别，怎么选？",
    a: "两者更多是地区与题材倾向上的差别：欧美大片通常偏向科幻、动作与系列化制作，注重视听效果；国产剧则覆盖古装、年代与现实题材，更贴近本土语境。你可以在对应分区对照条目后再做选择。",
  },
  {
    id: "f4",
    q: "本页的筛选和搜索是怎么工作的？",
    a: "本页的筛选与搜索只作用于当前页面已经展示的内容，不会请求外部数据。你可以按地区、类型筛选，或在搜索框输入片名关键词，结果会实时更新并显示匹配数量。",
  },
  {
    id: "f5",
    q: "页面上的条目信息可以当作最终依据吗？",
    a: "页面内容用于帮助你了解内容分类与大致方向，条目说明以一般性描述为主。具体是否观看，建议结合自己的偏好与更多渠道的信息综合判断。",
  },
];